<ngx-spinner
  bdColor="rgba(255,255,255,0.5)"
  size="medium"
  color="#142687"
  type="ball-spin-clockwise"
  [fullScreen]="true"></ngx-spinner>
<router-outlet></router-outlet>
